import {ActionType} from "../actionTypes";
import {ErrorDtoFactory, UploadProgressingImagesDto, UserDto} from "../../dtos";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";
import {Action as ProgressPopupActions} from "../actions/uploadingImagesProgressActions";
import {Action as DownloadFileActions} from "../actions/downloadFileActions";
import {Dispatch} from "redux";


export const downloadFile = (flyerId: number, flyerCaption: string) => {
    return async (
        dispatch: Dispatch<DownloadFileActions | ProgressPopupActions>
    ) => {
        dispatch({
            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_START,
            payload: {
                title: "Creating File..."
            }
        });
        dispatch({
            type: ActionType.DOWNLOAD_FILE_START,
        });

        try {
            let result: any = await getFlyerPdf(flyerId, dispatch);
            dispatch({type: ActionType.DOWNLOAD_FILE_SUCCESS, payload: result});
            const url = window.URL.createObjectURL(new Blob([result.data])); // you can mention a type if you wish
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${flyerCaption}.pdf`); //this is the name with which the file will be downloaded
            link.click();
            // no need to append link as child to body.
            setTimeout(() => window.URL.revokeObjectURL(url), 50);
            dispatch({type: ActionType.DOWNLOAD_FILE_COMPLETE});
        } catch (err) {
            dispatch({
                type: ActionType.DOWNLOAD_FILE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
            dispatch({
                type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE,
            });
        }
    };

}

const getFlyerPdf = (flyerId: number, dispatch: any) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    return new Promise(async (resolve, reject) => {
        try {
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/GetFlyerPdf?flyerId=${flyerId}`;
            let result: any = await axios.get(url, {
                responseType: 'blob',
                headers: {
                    contentType: 'application/json; charset=utf-8',
                    Authorization: "Bearer " + userDto.token,
                },
                onDownloadProgress: progressEvent => {
                    const data: UploadProgressingImagesDto = {
                        failCount: 0,
                        notUploadedImages: null,
                        isUploadingFilesToSystem: progressEvent.loaded !== progressEvent.total,
                        isUploadingFilesToSystemFinished: progressEvent.loaded === progressEvent.total,
                        current: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.loaded,
                        processingFinished: progressEvent.loaded === progressEvent.total,
                        successCount: 0,
                        severityLevel: '',
                        total: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.total,
                        titlePopup: `Downloading file...`
                    }
                    dispatch({
                        type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
                        payload: data
                    });
                    if(progressEvent.loaded === progressEvent.total){
                        dispatch({
                            type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE,
                        });
                    }
                }
            });

            resolve(result);
        } catch (error) {
            new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    if (typeof reader?.result === "string") {
                        error.response.data = JSON.parse(reader?.result);
                    }
                    resolve(error);
                };

                reader.onerror = () => {
                    reject(error);
                };

                reader.readAsText(error.response.data);
            })
                .then(err => {
                    // here your response comes
                    reject(err);
                })
        }
    });
};
